import React from 'react'

const AboutOverview = () => {
  return (
    <section id="c-sectionAboutOverview" className="c-sectionWrapper">
		<div className="container">
			<div className="row">
				<div className="col-lg-6 col-md-12">
					<div className="c-sectionHeader">
						<h5 className="c-heading46Bold">Overview</h5>										
						<p className="c-para18Regular">
							Finayo is one of India’s leading green mobility embedded lending technology solution company that aims to revolutionize the rapidly evolving EV business in the country. In simple words, we intend to digitize the entire process of EV lending using our advanced technological solution to provide real time loans to the customers of EVs- both retailers and OEMs. Our objective is to digitize the end-to-end lending process with the help of modern technologies like Artificial Intelligence and Machine Learning, Blockchain and IoT.
							<br/><br/>
							The growing e-mobility revolution has led to a gradual change in the consumption behaviour for million of families in India, which requires furnishing convincing loan offers to prospective buyers. Our advanced B2B platform connects Banks/NBFCs with the customers of the EV retailers, helping them make credit decisions faster and efficient, and thereby helping these retailers and OEMs to receive ‘financing in minutes’ for their customers.
						</p>
					</div>
				</div>
				<div className="col-lg-6 col-md-12">
					<div className="c-auoBoxes">
						<div className="c-auoBox c-auoBox1">
							<div className="c-auoBoxIcon">
								<img src="./images/aboutus/auo_icon_1.png" alt="" title="" />
							</div>
							<div className="c-auoBoxInfo">
								<div className="c-auoBoxTitle">Powered by technology</div>
								<div className="c-auoBoxPara">We offer a range of tools and platforms that allow you to plug, play and go digital in under a few hours.</div>
							</div>
						</div>
						<div className="c-auoBox c-auoBox2">
							<div className="c-auoBoxIcon">
								<img src="./images/aboutus/auo_icon_2.png" alt="" title="" />
							</div>
							<div className="c-auoBoxInfo">
								<div className="c-auoBoxTitle">Believe In Partnership</div>
								<div className="c-auoBoxPara">We believe in value of transparency. We will never launch our own competing
									products because our aim is not compete we are dealing in to grow with partners.</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  )
}

export default AboutOverview